export const TableHeaders = [
  { column: 'readingDate', label: 'Date', width: '15%', sortBy: 'value' },
  { column: 'height', label: 'Height (in)', width: '15%', sortBy: 'value' },
  { column: 'weight', label: 'Weight (lbs)', width: '15%', sortBy: 'value' },
  { column: 'bloodPressure', label: 'Blood Pressure (mmHg)', width: '15%', sortBy: 'value' },
  { column: 'bmi', label: 'BMI', width: '22%', sortBy: 'value' },
  { column: 'actions', label: 'Actions', width: '18%' },
];
